import { render, staticRenderFns } from "./addDeviceTem.vue?vue&type=template&id=c6a51852&scoped=true"
import script from "./addDeviceTem.vue?vue&type=script&lang=js"
export * from "./addDeviceTem.vue?vue&type=script&lang=js"
import style0 from "./addDeviceTem.vue?vue&type=style&index=0&id=c6a51852&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6a51852",
  null
  
)

export default component.exports